<template>
  <div>
    <vx-card :title="`Список товаров | Всего ${totalProducts}`" class="p-6">
      <vs-row class="mb-10">
        <vs-button
          :to="{ name: 'new-market-product' }"
          class="rounded-full"
          color="primary"
          icon-pack="feather"
          icon="icon-plus-circle"
          type="filled"
          >Создать товар</vs-button
        >
      </vs-row>
      <vs-row class="mb-5">
        <div class="header-filter md:w-1/6 w-full mb-5 mr-5 cursor-pointer">
          <v-select
            @input="getProducts()"
            :options="countItemsOmPage"
            :clearable="false"
            placeholder="Количество товаров"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </vs-row>

      <template v-if="products">
        <vs-row class="-mx-4">
          <vs-col
            v-for="(product, index) in products"
            :key="index"
            class="w-full px-4 sm:w-6/12 lg:w-3/12 mb-base"
          >
            <router-link
              :to="{ path: `/market/products/${product.id}` }"
              class="text-black"
            >
              <vs-card actionable class="cardx pb-1">
                <div slot="media">
                  <img
                    v-if="product.image !== null"
                    :src="BASE_URL + product.image"
                    :alt="product.name"
                  />
                </div>
                <div>
                  <h4>{{ product.name }}</h4>
                  <p v-if="product.category">
                    Категории:
                    <span class="text-primary font-bold">{{
                      product.category.name
                    }}</span>
                    /
                    <span class="text-primary font-bold">{{
                      product.category.category.name
                    }}</span>
                  </p>
                  <p v-else class="text-danger">Категории отсутствуют</p>
                  <p>
                    Цена:
                    <span class="text-primary">{{ product.price }} руб.</span>
                  </p>
                  <p>
                    Вес:
                    <span class="text-primary">{{ product.weight }} кг.</span>
                  </p>
                  <p>
                    Описание:
                    <span class="text-primary">{{ product.description }}</span>
                  </p>
                </div>
                <div slot="footer"></div>
              </vs-card>
            </router-link>
          </vs-col>
        </vs-row>

        <vs-pagination
          class="mt-4"
          :total="totalPagePagination"
          v-model="currentPagingationPage"
        ></vs-pagination>
      </template>
      <template v-else>
        <h5>Товаров нет</h5>
      </template>
    </vx-card>
  </div>
</template>
<script>
import { API_URL, countItemsOmPage } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    products: [],

    filter: {},
    countElements: 20,
    currentPagingationPage: 1,
    totalProducts: 0,
    totalPagePagination: 1,
    countItemsOmPage,
  }),
  components: {},
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getProducts();
    },
    currentPagingationPage: function () {
      this.getProducts();
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getProducts() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.market.getProducts(this.filter)).data;

        this.totalProducts = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalProducts / this.countElements
        );

        this.products = res.results;
        this.$vs.loading.close();
      });
    },
  },
  created() {},
  mounted() {
    this.getProducts();
  },
};
</script>